import { Component, h, Host, Prop } from "@stencil/core";
import { PopoverPlacementType } from "../popover/interface";

@Component({
    tag: "ux-popover-menu",
    styleUrl: "popover-menu.scss",
    shadow: false
})
export class PopoverMenu {
    /** component base class */
    private baseClass = "ux-popover-menu";

    /** placement of the overlay */
    @Prop() readonly placement: PopoverPlacementType = "bottom-end";

    render() {
        return (
            <Host class={`${this.baseClass} ${this.baseClass}__${this.placement}`}>
                <ux-popover placement={this.placement}>
                    <div class={`${this.baseClass}__toggle`} slot='trigger'>
                        <span></span>
                    </div>
                    <ux-popover-panel>
                        <div class={`${this.baseClass}__content`}>
                            <slot />
                        </div>
                    </ux-popover-panel>
                </ux-popover>
            </Host>
        );
    }
}
